var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 7.5H18.3333V12.5H11.6667V7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2.5H4.16667C2.78833 2.5 1.66667 3.62167 1.66667 5V15C1.66667 16.3783 2.78833 17.5 4.16667 17.5H16.6667C17.5858 17.5 18.3333 16.7525 18.3333 15.8333V14.1667H11.6667C10.7475 14.1667 10 13.4192 10 12.5V7.5C10 6.58083 10.7475 5.83333 11.6667 5.83333H18.3333V4.16667C18.3333 3.2475 17.5858 2.5 16.6667 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsWallet);
export default __webpack_public_path__ + "static/media/bxs-wallet.c76bcaf30d40d11a37abc9be655157dc.svg";
export { ForwardRef as ReactComponent };